'use client';

import { cn } from '../_lib/utils';
import { Card, type CardProps } from '../Card';

export type FeaturedCardListProps = {
	className?: string;
	featuredCard?: CardProps;
	cards: (CardProps | null)[];
};

export function FeaturedCardList(props: FeaturedCardListProps) {
	return (
		<article className={cn('container-xl grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-4 lg:gap-10', props.className)}>
			<div>
				<div className='sticky top-0 pt-10 md:pt-20 lg:py-20'>{props.featuredCard && <Card {...props.featuredCard} className='' />}</div>
			</div>
			<div className='pb-10 md:pb-20 lg:py-20 md:gap-4 flex flex-col gap-6 *:h-auto!'>
				{props.cards.map((card, index) => card && <Card key={`${index}-${card.title}`} {...card} />)}
			</div>
		</article>
	);
}
